export const API_ENDPOINTS = {
    SOLDOUT_PRODUCTS: '/apps/store/api/v1.1/soldout-products',
    FILTERED_DATA: ({ publishedCatalogId, catalogType, customerId }) =>
        `/apps/store/rest/filters/catalog/${publishedCatalogId}/${catalogType}/customer/${customerId}`
}